import { Component, EventEmitter, Input, Output, forwardRef, HostBinding } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SliderComponent implements ControlValueAccessor {
  isDragging = false;
  @Input() min = 0;
  @Input() max = 100;
  @Input() step = 1;
  @Input() value = 0;
  @Input() formControlName: string;
  @Input() name = '';
  @Input() disabled = false;
  @Input() showValue = false;
  @Input() valueFormatter = (value: number) => value;
  @Input() sliderColor = '--clr-primary-600';

  @Output() valueChange = new EventEmitter<number>();

  onChange: (_: number) => void;
  onTouch: (_: number) => void;

  constructor() {
    this.onChange = () => {};
    this.onTouch = () => {};
  }

  get progress(): number {
    return ((this.value - this.min) / (this.max - this.min)) * 100;
  }

  onInputChange(event: any) {
    this.value = +event.target.value;
    this.onChange(this.value);
  }

  writeValue(value: number): void {
    this.value = value || 0;
  }
  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }
  onSliderChange(event: any) {
    const newValue = +event.target.value;
    this.valueChange.emit(newValue);
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  onDragStart() {
    this.isDragging = true;
  }

  onDragEnd() {
    this.isDragging = false;
  }

  @HostBinding('style.--slider-color')
  get sliderColorVar(): string {
    return `var(${this.sliderColor})`;
  }
}
